import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=2916a8f1&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=js"
export * from "./ProjectInfo.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=2916a8f1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2916a8f1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\XWork\\ProjectSystem\\铂诺客SaaS\\devicenewweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2916a8f1')) {
      api.createRecord('2916a8f1', component.options)
    } else {
      api.reload('2916a8f1', component.options)
    }
    module.hot.accept("./ProjectInfo.vue?vue&type=template&id=2916a8f1&scoped=true", function () {
      api.rerender('2916a8f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Before/ProjectInfo.vue"
export default component.exports